const BASE_URL = '/api';
const PRODUCTS_URL = '/products';
const USERS_URL = '/users';
const ORDERS_URL = '/orders';
const ADDRESS_URL = '/address';
const EMAIL_URL = '/email';
const SMS_URL = '/sms';
const WHATSAPP_URL = '/whatsapp';
const REVIEW_URL = '/review';
const UPLOAD_URL = '/upload';
const FILES_URL = '/files';
const RAZORPAY_URL='https://checkout.razorpay.com/v1/checkout.js';

export default BASE_URL;

export {
  BASE_URL,
  PRODUCTS_URL,
  USERS_URL,
  ORDERS_URL,
  ADDRESS_URL,
  RAZORPAY_URL,
  UPLOAD_URL,
  EMAIL_URL,
  SMS_URL,
  WHATSAPP_URL,
  REVIEW_URL,
  FILES_URL
};